export default "__VITE_ASSET__DK277Qao__";